import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StrojeviService {
  constructor(private _http: HttpClient) {}

  dohvatiSveStojeve(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_strojeve', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveLinije(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_linije', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveStrojeve(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_proces_stroj', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProcese(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_proces', a)
      .pipe(map((res: any) => res));
  }

  urediStroj(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'uredi_processtroj', a)
      .pipe(map((res: any) => res));
  }

  kreirajStroj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'kreiraj_processtroj', a)
      .pipe(map((res: any) => res));
  }

  obrisiStroj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'obrisi_proces_stroj', a)
      .pipe(map((res: any) => res));
  }

  pravaKorisnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'prijavaprava', a)
      .pipe(map((res: any) => res));
  }
}
